import { Injectable, NgZone } from '@angular/core';
import { ResponsiveSize } from '@mdd/api';
import { BehaviorSubject } from 'rxjs';
import { Responsive } from '../presentation/delegates';

@Injectable()
export class MediaQueryService implements Responsive {
    readonly change: BehaviorSubject<ResponsiveSize>;
    readonly handset: BehaviorSubject<boolean>;
    readonly tablet: BehaviorSubject<boolean>;
    readonly mobile: BehaviorSubject<boolean>;
    readonly desktop: BehaviorSubject<boolean>;
    readonly tabletBreak = 14 * 64;
    readonly desktopBreak = 23 * 64;
    private handsetMq: MediaQueryList;
    private tabletMq: MediaQueryList;
    private mobileMq: MediaQueryList;
    private desktopMq: MediaQueryList;

    constructor(private ngZone: NgZone) {
        this.handsetMq = matchMedia(`(max-width: ${this.pixelsToEm(this.tabletBreak - 1)})`);

        this.tabletMq = matchMedia(
            `(min-width: ${this.pixelsToEm(this.tabletBreak)}) and ` +
                `(max-width: ${this.pixelsToEm(this.desktopBreak - 1)})`
        );

        this.mobileMq = matchMedia(`(max-width: ${this.pixelsToEm(this.desktopBreak - 1)})`);

        this.desktopMq = matchMedia(`(min-width: ${this.pixelsToEm(this.desktopBreak)})`);

        let type: ResponsiveSize = 'desktop';
        if (this.handsetMq.matches) {
            type = 'handset';
        } else if (this.tabletMq.matches) {
            type = 'tablet';
        }

        this.change = new BehaviorSubject(type);
        this.handset = new BehaviorSubject(this.handsetMq.matches);
        this.tablet = new BehaviorSubject(this.tabletMq.matches);
        this.mobile = new BehaviorSubject(this.mobileMq.matches);
        this.desktop = new BehaviorSubject(this.desktopMq.matches);
        this.handsetMq.addListener((e) => {
            this.ngZone.run(() => {
                this.handset.next(e.matches);
                if (e.matches) {
                    this.change.next('handset');
                }
            });
        });

        this.tabletMq.addListener((e) => {
            this.ngZone.run(() => {
                this.tablet.next(e.matches);
                if (e.matches) {
                    this.change.next('tablet');
                }
            });
        });

        this.mobileMq.addListener((e) => {
            this.ngZone.run(() => {
                this.mobile.next(e.matches);
            });
        });

        this.desktopMq.addListener((e) => {
            this.ngZone.run(() => {
                this.desktop.next(e.matches);
                if (e.matches) {
                    this.change.next('desktop');
                }
            });
        });
    }

    pixelsToEm(pixels: number): string {
        return `${pixels / 16}em`;
    }
}
